import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TasksState } from './TasksState';

export interface IncreasePendingTaskCountPayload {}

export interface DecreasePendingTaskCountPayload {}

const initialState: TasksState = {
  pendingTaskCount: 0
};

export const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    increasePendingTaskCount(state) {
      state.pendingTaskCount += 1;
    },
    decreasePendingTaskCount(state) {
      state.pendingTaskCount -= 1;
    }
  }
});

export const { increasePendingTaskCount, decreasePendingTaskCount } = tasksSlice.actions;

export default tasksSlice.reducer;

type SliceActions<T> = {
  [K in keyof T]: T[K] extends (...args: never[]) => infer A ? A : never;
}[keyof T];

type ActionTypes = SliceActions<typeof tasksSlice.actions>;

export const increasePendingTaskCountType = 'tasks/increasePendingTaskCount';
export type IncreasePendingTaskCountAction = Extract<
  ActionTypes,
  PayloadAction<IncreasePendingTaskCountPayload, typeof increasePendingTaskCountType>
>;

export const decreasePendingTaskCountType = 'tasks/decreasePendingTaskCount';
export type DecreasePendingTaskCountAction = Extract<
  ActionTypes,
  PayloadAction<DecreasePendingTaskCountPayload, typeof decreasePendingTaskCountType>
>;
